const componentPropertyTypesConfig = {
    primereact: {
        Button: {
            label: {
                convertTo: "string",
                expectedTypes: ["string", "number"]
            }
        },
        Badge: {
            value: {
                convertTo: "string",
                expectedTypes: ["string"]
            }
        },
        ToggleButton: {
            onLabel: {
                convertTo: "string",
                expectedTypes: ["string"]
            },
            offLabel: {
                convertTo: "string",
                expectedTypes: ["string"]
            }
        },
        Tag: {
            value: {
                convertTo: "string",
                expectedTypes: ["string"]
            }
        }
    },
    code2: {
        C2Field: {
            c2FieldLabel: {
                convertTo: "string",
                expectedTypes: ["string"]
            },
            c2FieldHint: {
                convertTo: "string",
                expectedTypes: ["string"]
            },
            placeholder: {
                convertTo: "string",
                expectedTypes: ["string"]
            }
        },
        Label: {
            value: {
                convertTo: "string",
                expectedTypes: ["string", "number"]
            }
        },
        C2Header: {
            content: {
                convertTo: "string",
                expectedTypes: ["any"]
            }
        }
    }
};

export { componentPropertyTypesConfig };
//# sourceMappingURL=componentPropertyTypesConfig.js.map
